import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Station } from '@paragon/contract-library';

interface StationsState {
  [stationGuid: string]: Station;
}

const initialState: StationsState = {};

const stationsSlice = createSlice({
  name: 'stations',
  initialState,
  reducers: {
    stationsLoaded: (state, action: PayloadAction<readonly Station[]>) => {
      for (const station of action.payload) {
        state[station.guid] = station;
      }
    },
    // Note that this action is used in synchronization and sometimes dispatched by DesignService, so take care when
    //   modifying it.
    loadStation: (state, action: PayloadAction<{ station: Station }>) => {
      const { station } = action.payload;
      state[station.guid] = station;
    },
  },
});

export const { loadStation, stationsLoaded } = stationsSlice.actions;
export const stations = stationsSlice.reducer;
